'use strict';

export const contenido=[
  		{
  			texto: "Home",
  			link: "home",
  			variables: [
  				['¡BIENVENIDO!'],
  				['Aquí obtendrás acceso a todos nuestros materiales de las 3 marcas: Royal Caribbean,'],
  				['Celebrity Cruises y Azamara Cruises.'],
  				['PROMO PDF'],
  				['Precios Especiales'],
  				['Incentivo Agentes de Viajes'],
  				['GENERAL'],
  				['DOCUMENTOS DE VIAJE'],
  				['PREPARATIVOS VIAJE'],
  				['SERVICIOS A LOS HUÉSPEDES'],
  				['POLÍTICAS A BORDO'],
  				['POLÍTICAS DE CANCELACIÓN Y PENALIDADES DE RESERVA'],
  				['EMBARQUE Y DESEMBARQUE'],
  				['NOTICIAS']
  			]

  		},
  		{
  			texto: "General",
  			colapsar: false,
  			hijos: [
  				{
  					texto: "Documentos de Viaje",
  					link: "travel-documents",
  					variables: [
  						["DOCUMENTOS DE VIAJE"],
  						["Antes de Salir de Casa"],
  						["Dedica un poco de tiempo y conoce los documentos de viaje necesarios que serán solicitados antes de embarcar."],
  						["Todo destino Internacional al que se llegue por tierra o por avión requiere pasaporte válido."],
  						["Por favor, invite al pasajero a revisar que la fecha de vencimiento de su pasaporte no coincida con la época de su crucero. Todos los pasajeros que no sean ciudadanos americanos deberán tener pasaporte con una validez de por lo menos 6 meses y visa de entradas múltiples a los Estados Unidos. Indique al pasajero que es de su responsabilidad total de acuerdo a su nacionalidad, verificar si necesita visa para alguno de los puertos visitados en su itinerario."],
  						["Todos los documentos de viaje, tales como pasaportes, visas, pruebas de nacionalidad, etc., que se requieran para embarcar y desembarcar en los diversos puertos de escala, deberá obtenerlos el pasajero. Por favor, pregunte a las entidades gubernamentales, embajadas o consulados, qué documentos les serán exigidos."],
  						["Es totalmente responsabilidad de los pasajeros obtener los documentos apropiados y válidos tales como pasaporte y visas. No se permitirá a los pasajeros abordar al barco sin los documentos apropiados, y no se hará ninguna devolución del pago del crucero a ningún pasajero que no lleve consigo tales documentos."],
  						["Igualmente, le rogamos tener en cuenta que por razones de inmigración y aduanas, los oficiales de la Recepción del Barco “Guest Relations Desk” podrían conservar su pasaporte mientras dure el crucero. Sus documentos de viaje se les devolverán en la fecha de su desembarco, por lo que sugerimos le recomiende al pasajero siempre llevar otra identificación oficial o copia de su pasaporte."],
  						["Indique al pasajero, verificar en su pasaje y en su pasaporte aparezca exactamente el mismo nombre (inclusive las iniciales). Si hay alguna diferencia, podrá impedírsele que aborde su vuelo o al barco. Lamentamos no poder asumir ninguna responsabilidad si se le impide abordar cualquier vuelo o barco, entrar a cualquier país, o si sufre otras dificultades o debe pagar algunos costos como consecuencia de la falta de un pasaporte aceptable o de cualquier visa necesaria."],
  						["Si desean conocer más información acerca de todos los visados es necesario que visten la página oficial de SER (secretaria de relaciones exteriores) para conocer los visados de cada país."],
  						["Vacunas y Sanidad"],
  						["Haga saber al pasajero que debe asegurarse de que su estado físico y sanitario sea el idóneo para viajar. Los Centros para el Control y la Prevención de Enfermedades (CDC) y la Organización Mundial de la Salud (OMS) ofrecen pautas sobre las vacunas exigidas en cada país. En muchos casos, se recomiendan las vacunas, pero en otros son obligatorias. Para más información puede recomendar al pasajero que consulte con su médico o puede ingresar en el sitio web de la Organización Mundial de la Salud."],
  						["Documentos legales de familia y restricciones de edad"],
  						["Se considera mayoría de edad a partir de los 21 años. No se permite viajar solos en un camarote a menores de 21 años, a menos que vayan acompañados por el padre, la madre o tutor de 21 años o mayor. En el caso de matrimonios y ambos menores de 21 años, pero mayores de 18, se requerirá un certificado de matrimonio en el momento de realizar la reserva. Los menores de 21 años que NO viajen acompañados de sus padres o tutores legales, deberán presentar en el momento del embarque un documento notarial legal de quien ejerza la patria potestad o tutela autorizando al menor a realizar el viaje. Si el adulto que viaja con el menor es su tutor legal, deberá presentar el certificado oficial de tutoría respecto al menor. A bordo hay algunas instalaciones en las que se limita la entrada por edad del pasajero. En el programa diario encontrarán información acerca de las restricciones de edades para entrar a determinadas instalaciones. La edad del pasajero al momento de embarcar determinará su estatus para el resto del crucero."],
  						["Descargar Carta Notariada para Menores"],
  						["Requerimientos de Visado para viajar a Canadá"],
  						["Los Ciudadanos de México cuando visiten Canadá con el propósito de realizar turismo no será necesario de un visado. Sin embargo, a partir de 1 de diciembre de 2016 todas las personas mexicanas deben tramitar una Autorización Electrónica de Viaje (eTA) para ingresar a Canadá vía aérea."]
  					]
  				},
				{
					texto: "Preparativos de Viaje",
					link: "travel-prepatation",
					variables: [
						["PREPARATIVOS DE VIAJE"],
						["Qué llevar en el equipaje"],
						["Los días a bordo del barco se viven en un ambiente relajado, por lo que el pasajero puede usar ropa deportiva e informal. Traer zapatos de tacón bajo para las actividades en cubierta. Traer varios trajes de baño (de modo que siempre disponga de uno seco). Necesitará zapatos cómodos para caminar cuando esté en tierra."],
						["Para usar por la noche, debe contar con tres tipos básicos de ropa."],
						["Informal: vestidos de playa o pantalones y blusas para las mujeres; camisas polo y pantalones para los hombres."],
						["Informal Elegante: vestidos o trajes de chaqueta y pantalón para las mujeres; chaquetas para los hombres."],
						["Formal: vestidos de cóctel para las mujeres; trajes y corbatas o esmóquines para los hombres."],
						["Si el viaje es por el Caribe, México u otros destinos de clima cálido, se recomienda llevar un sombrero para protegerse del sol. Si sus vacaciones en crucero le llevarán por Alaska, Canadá y Nueva Inglaterra o el norte de Europa, deberá incluir una chaqueta y varios suéteres."],
						["Es importante que lleve en su equipaje de mano todos los medicamentos, objetos de valor, objetos frágiles, prueba de identidad y prueba de ciudadanía, y cualquier otro artículo que usted pueda necesitar antes de que su equipaje facturado le sea entregado en su camarote."],
						["Vestimenta de noche"],
						["La siguiente información le ayudará a planificar su ropa de noche para cuando esté a bordo:"],
						["Crucero (Noches)"],
						["Informal"],
						["Informal Elegante"],
						["Formal"],
						["3 - 5"],
						["2 - 4"],
						[""],
						["1"],
						["6 - 9"],
						["3 - 6"],
						["1"],
						["2"],
						["10 - 12"],
						["5 - 7"],
						["3"],
						["2"],
						["13 - 15"],
						["6 - 8"],
						["4"],
						["3"],
						["Lleve un bolso de viaje pequeño para su última noche en alta mar. El personal recogerá sus maletas la noche anterior al desembarque, y usted necesitará un bolso de viaje pequeño para llevar su ropa de dormir y artículos de tocador."],
						["Qué no hay que llevar"],
						["Para la seguridad de nuestros huéspedes, ciertos artículos no están permitidos a bordo del barco: Están prohibidos las armas, las drogas ilegales y otros artículos que pudieran interferir con la seguridad en el funcionamiento del barco o con la seguridad del entorno para nuestros pasajeros y nuestra tripulación. Los siguientes son algunos de los artículos que no están permitidos a bordo. El Equipo de Seguridad confiscará estos artículos y otros similares cuando los encuentre."],
						["Artículos Prohibidos"],
						["Armas de fuego y municiones, incluyendo réplicas realistas; objetos cortantes o punzantes, incluyendo cuchillos y tijeras. (Nota: Están permitidos objetos de aseo personal, tales como maquinillas de afeitar); drogas y sustancias ilegales; velas e incienso; cafeteras, planchas para ropa y calientaplatos portátiles, bates de béisbol, palos de hockey, paletas de cricket, arcos y flechas; patinetas y tablas de surf; equipos para artes marciales; equipos de autodefensa, incluyendo esposas, spray de pimienta, garrotes; líquidos inflamables y explosivos, incluyendo líquidos para encendedores y fuegos artificiales; radios HAM; productos químicos peligrosos, incluyendo lejía y pintura; alcohol personal. Secadores de cabello y lavandería. Para beneficio de nuestros huéspedes, todos los barcos ofrecen secadores de cabello. Por un cargo muy razonable, ofrecemos un servicio de lavandería y limpieza en seco en sólo un día. No hay planchas en los camarotes ya que pueden provocar un incendio. No hay instalaciones de lavandería de autoservicio a bordo."]
					]
				},
				{
					texto: "Servicios a los Huépedes",
					link: "services-guests",
					variables: [
						["SERVICIOS A LOS HUÉSPEDES"],
						["Módulo de Información"],
						["Abierto las 24 horas del día para contestar cualquier pregunta que usted pueda tener."],
						["Servicio a la Habitación"],
						["El servicio de habitaciones a bordo está disponible a cualquier hora del día y de la noche. El pasajero puede pedir lo que necesite del menú de servicio de habitaciones que encontrará en su camarote o suite. A todos los pedidos se les añadirá un suplemento, en el que se incluye el cobro de servicios. Este suplemento se aplica a todos los pedidos, excepto a los artículos del menú correspondientes al desayuno continental, que son gratuitos."],
						["Propinas"],
						["El personal a bordo y la tripulación de Royal Caribbean International lo esperan con nuestro servicio Personalizado “Gold Anchor”. Se agregará diariamente a su cuenta una propina por huésped de $ 14.50 usd ($ 17.50 usd para los huéspedes en Suites), esta será repartida con el personal del comedor, el personal de servicio a camarotes y otros servicios de limpieza que trabajen en mejorar su experiencia de Crucero. Estas propinas pueden ser pagadas antes de abordar. Los huéspedes que paguen sus propinas antes de abordar NO se les agregaran diariamente el cargo automático a su cuenta por este concepto. Una propina del 18% se incluye automáticamente a las bebidas, artículos de mini bar, servicios de spa y salón de belleza. Muchos de nuestros clientes desean recompensar los servicios excepcionales recibidos durante su crucero, otorgando propinas adicionales a nuestra tripulación. Los huéspedes pueden hacerlo incluyendo propinas adicionales con cargo a su cuenta o con una propina en efectivo a su discreción."],
						["Cruise Compass / Celebrity Today / Your Daily Program"],
						["Periódico diario del barco, se entrega en su camarote todas las noches y refleja las actividades del siguiente día, los horarios de funcionamiento de todos los locales y mucho más. En Royal Caribbean tiene el nombre de Cruise Compass, para Celebrity Cruises Celebrity Today y para Azamara Club celebrity-cruisess Your Daily Program."],
						["Llamadas a su casa desde el barco"],
						["Usted puede llamar del barco a tierra desde su camarote, las 24 horas del día. El costo se cargará automáticamente a su cuenta."],
						["Compras a bordo"],
						["Royal Caribbean International ofrece la tarjeta SeaPass(SM), una forma cómoda de pagar todas las compras que se realicen a bordo, así como las excursiones en tierra (se cargan a su cuenta en dólares de EE. UU.). Para abrir una cuenta SeaPass, solamente debe presentar su tarjeta Visa, tarjeta MasterCard, tarjeta American Express, tarjeta Diners Club International o Efectivo/Cheques de viajero. La última mañana de las vacaciones en crucero, se le entregará al pasajero en su camarote un estado de su cuenta, detallado."],
						["Se acepta dinero en efectivo en el casino, para las propinas y para cambio de moneda extranjera."],
						["Idioma"],
						["Por consideración a nuestros huéspedes que hablan español, alemán, francés, italiano y portugués, hemos hecho todo lo posible para brindar la información a bordo en estos idiomas en todos nuestros itinerarios. Nuestro canal internacional de idiomas emite continuamente vídeos informativos, y todos los menús de nuestro comedor están disponibles en estos idiomas. Además, a las personas que viajen en cualquiera de nuestros itinerarios asiáticos, les proporcionamos también información en chino, japonés y coreano. Usted debe también saber que hay a bordo un Embajador Internacional para ayudarle. Las horas y la ubicación de nuestro Embajador Internacional están indicadas en el periódico que se brinda diario a bordo, y también están expuestas en el Mostrador de Relaciones con los Huéspedes."]
					]
				},
				{
					texto: "Políticas Abordo",
					link: "policies-board",
					variables: [
						["POLÍTICAS A BORDO"],
						["Política sobre el Consumo de Bebidas Alcohólicas"],
						["Se prohíbe a los huéspedes llevar bebidas alcohólicas a bordo para su consumo o cualquier otro uso. Las bebidas alcohólicas que se adquieran en puertos de escala o en tiendas a bordo serán retenidas por el barco y entregadas en los camarotes de los huéspedes el último día de viaje. El personal de seguridad del barco podrá inspeccionar todo tipo de recipientes (botellas de agua, botellas de refresco, enjuague bucal, equipaje, etc.) y desechará cualquier recipiente que contenga bebidas alcohólicas. Si algún huésped viola cualquier política sobre el consumo de bebidas alcohólicas, podrá aplicarse la Política de Royal Caribbean International sobre Conducta de los Huéspedes, que incluye la posibilidad de su desembarco. Ningún recipiente de bebida alcohólica que se le encuentre a un huésped menor de 21 años le será devuelto al mismo. De acuerdo con nuestras Políticas de Conducta de los Huéspedes, se podrá obligar a desembarcar, o se le podrá prohibir la subida a bordo, a todo huésped que viole cualquiera de las políticas sobre el consumo de bebidas alcohólicas (consumo en exceso, proporcionar alcohol a menores de 21 años, comportarse de forma irresponsable o intentar ocultar productos alcohólicos en puestos de seguridad y/o de control de equipaje o en cualquier otro momento), a su propia costa. Royal Caribbean International se reserva el derecho de revocar o restringir de cualquier otra manera los privilegios de consumo de bebidas alcohólicas de cualquier huésped, independientemente de su edad. La edad mínima permitida para el consumo de cualquier bebida alcohólica en los Barcos de Royal Caribbean International es de 21 años. Sin embargo, en los cruceros que zarpen de países de Europa o de Sudamérica, donde la edad legal para consumir bebidas alcohólicas es por lo general inferior a 21 años, el padre o madre que viaje con su hijo o hija de entre 18 y 20 años podrá firmar una dispensa para que dicho(a) joven pueda consumir bebidas alcohólicas. Tales jóvenes de entre 18 y 20 años de edad deberán aceptar cumplir con las políticas de Royal Caribbean International, que incluyen, entre otras cuestiones, el no proporcionar bebidas alcohólicas a ninguna otra persona, independientemente de la edad. Existen ciertas restricciones y esta política está sujeta a cambios sin previo aviso."],
						["Política sobre Fumadores"],
						["Para comodidad y disfrute de nuestros huéspedes, nuestros barcos han sido designados principalmente para pasajeros no fumadores. Sin embargo, sabemos que algunos de nuestros huéspedes sí fuman, por lo que disponemos de áreas designadas a bordo que también satisfacen a los fumadores, tanto en algún espacio interior como en las cubiertas al aire libre, de estribor. No está permitido fumar dentro de ningún camarote, ni tampoco en los balcones ni terrazas de los mismos. Para proteger todas las declaraciones que prohíben fumar, la línea de cruceros agregará un cargo por limpieza de US a la cuenta de cualquier huésped que fume o permita fumar en su camarote, donde está prohibido fumar. Este cargo no se aplicará en los cruceros por Asia o Brasil, ni en los que salen de República Dominicana, aunque los huéspedes que infrinjan nuestra política sobre fumadores en dichos cruceros podrán estar sujetos a otras medidas que disponga la línea de cruceros, según se resume en nuestra Política sobre Conducta de los Huéspedes."],
						["Código de Conducta de Royal Caribbean International"],
						["Para la seguridad y comodidad de nuestros huéspedes, Royal Caribbean International ha desarrollado una Política sobre Conducta de los Huéspedes, tanto para adultos como para niños. Si Royal Caribbean International determina que ciertos huéspedes están infringiendo estas pautas, podríamos vernos obligados a solicitar al infractor que abandone el barco en el próximo puerto de escala. Le rogamos que se asegure de conocer el contenido de dichas pautas, que podrá encontrar en nuestro sitio web: www.royalcaribbean-espanol.com en la sección de LEGALES. En la Sección Customer Support [Servicios al Cliente] y en su camarote, en el Directorio de Servicios a los  Huéspedes."],
						["Save the Waves"],
						["Save the Wave es un programa patrocinado por Royal Caribbean International que lucha para proteger la ecología de los océanos por donde navegan los cruceros. Es importante que los pasajeros tengan una conducta favorable y no arrojen nada por la borda, ni en puerto ni en alta mar, y depositen la basura en los receptáculos correspondientes."],
						["Embarazo"],
						["Las embarazadas son bienvenidas en Royal Caribbean International, con excepción que vayan a entrar en la 24ª semana de embarazo al momento de iniciar el crucero o cruisetour, o en cualquier momento durante el viaje."],
						["Bebés"],
						["Para viajar en un crucero, los bebés deben tener por lo menos 6 meses de edad en la fecha del primer día del crucero o cruisetour. Sin embargo, para los cruceros/cruisetours Transatlánticos, Transpacíficos, por Hawái, determinados cruceros/cruisetours por América del Sur y otros cruceros/cruisetours selectos, los bebés (a la fecha del primer día del crucero/cruisetour) deben tener por lo menos 12 meses de edad. "]
					]
				},
				{
					texto: "Políticas de Cancelación y Penalidades de reserva",
					link: "policies-cancelation",
					variables: [
						["POLÍTICAS DE CANCELACIÓN Y PENALIDAD DE RESERVA"],
						["Itinerario"],
						["Depósito"],
						["Pago Final"],
						["1-5 Noches"],
						["$1.270.00"],
						["60 Días Antes de Navegar"],
						["6-8 Noches"],
						["$3,175.00"],
						["75 Días Antes de Navegar"],
						["9 Noches o Más"],
						["$5,715.00"],
						["75 Días Antes de Navegar"],
						["Cruceros Festivos"],
						["Según la Duración del Crucero"],
						["90 Días Antes de Navegar"],
						["Consideramos cruceros festivos las salidas de Navidad y Año Nuevo."],
						["Nota: Para reservaciones con menos de 75 días de antelación según la duración y temporada del crucero, se requiere el pago total."],
						["Información de depósitos"],
						["Es importante que el depósito requerido para garantizar tu reservación sea recibido en o antes de la fecha de opción que te dará la reserva. De no recibirse el depósito dentro de este plazo, la reservación es cancelada automáticamente por el sistema. Royal Caribbean International® hará todo lo posible para reestablecer tu reservación, pero no podrá garantizarte ni el espacio, ni la categoría, ni la tarifa originalmente confirmada."],
						["Los precios de los cruceros fluctúan de acuerdo al barco, a su itinerario y a la temporada. Para asegurarte de obtener los mejores precios disponibles de acuerdo a la fecha del viaje y a la categoría de camarote elegida, debes hacer las reservaciones con anticipación y/o verificar cuál es la mejor promoción."],
						["Días Antes de la Fecha de Partida"],
						["Cargos por Persona"],
						["1 A 5 Noches"],
						["60 o Más"],
						["Ninguno"],
						["59 a 43"],
						["Monto del Depósito"],
						["42 a 29"],
						["50% del Precio Total"],
						["28 a 15"],
						["75% del Precio Total"],
						["14 a Menos"],
						["No hay Reembolso"],
						["6 A 8 Noches"],
						["75 o Más"],
						["Ninguno"],
						["74 a 57"],
						["Monto del Depósito"],
						["56 a 29"],
						["50% del Precio Total"],
						["28 a 15"],
						["75% del Precio Total"],
						["14 a Menos"],
						["No hay Reembolso"],
						["Cruceros Festivos 6 Noches o Más"],
						["90 o Más"],
						["Ninguno"],
						["89 a 64"],
						["Monto del Depósito"],
						["63 a 43"],
						["50% del Precio Total"],
						["42 a 22"],
						["75% del Precio Total"],
						["21 a Menos"],
						["No hay Reembolso"],
						["Si cualquier persona que viaja desea cancelar sus vacaciones, deberá comunicarse con nosotros o realizarlo a través de nuestro sistema de reservaciones. El pasajero tendrá que pagar los cargos de cancelación correspondientes. Las primas de seguros (si las hubiera) y los cargos por cambio o servicio no pueden devolverse en caso de una cancelación. No se hará ninguna devolución en caso que el huésped no se presente (no-show), interrumpa o cancele después de que se inicie el crucero. No habrá reembolso por servicios no utilizados. Quienes viajen en grupo, deberán pedir la información relativa al depósito, el pago y la cancelación. Toda penalidad es por persona, por lo tanto, en el caso de cancelar una cabina triple o cuádruple dentro del período de los cargos para el tercer y cuarto huésped aplican igual que al primero y segundo huésped. En caso de cancelar únicamente el tercer y cuarto huésped, no habrá cargos siempre y cuando no se cancele posteriormente el camarote en su totalidad. En caso de cancelar el tercer y cuarto huésped dentro de la semana de la salida los cargos serán del 100%."],
						["Royal Caribbean LTD."]
					]
				},
				{
					texto: "Embarque y Desembarque",
					link: "board",
					variables: [
						["EMBARQUE Y DESEMBARQUE"],
						["Royal Caribbean Internationa"],
						["ofrece servicios de ayuda en el embarque y desembarque a los huéspedes con discapacidades motoras. Contamos con sillas de ruedas y con personal que ayudará a nuestros huéspedes a subir y bajar del barco. Recuerda que nuestro personal no está obligado a cargar a un huésped. Solicita el servicio de ayuda especial cuando llegues al muelle o ponte en contacto con nosotros antes de iniciar el crucero. Es posible que debas esperar brevemente durante las horas de mayor actividad."],
						["A continuación podrás ver las cosas más importantes que debe saber el pasajero justo antes y después de subirse a bordo."],
						["Para el primer día del crucero, debe preparar un bolso de mano pequeño con sus documentos de viaje, llevar una muda de ropa, traje de baño, ropa para hacer ejercicio y todos los medicamentos que vayas a necesitar. De esta forma, no tendrá que esperar a que dejen el equipaje registrado en su camarote."],
						["Royal Caribbean International exige a sus huéspedes que realicen el check-in 60 minutos antes, como mínimo, de la hora de la salida programada. Los huéspedes que lleguen con retraso no podrán embarcar. De esta forma, cumplimos las normas gubernamentales de algunos puertos que exigen que las compañías de cruceros entreguen el manifiesto de salida con 60 minutos de anticipación. Se solicita a los huéspedes que completen el check-in online a más tardar 3 días antes del crucero para agilizar el proceso de check-in en el muelle."],
						["Es posible que algunos viajes requieran realizar el check-in con mayor anticipación. Consulta la documentación de viaje para obtener información específica. "],
						["Tus amigos y familiares son bienvenidos al muelle para que se despidan. No obstante, por razones de seguridad, no se les permitirá que embarquen en ningún puerto."],
						["Ahora usamos etiquetas para el equipaje de un solo color en todos los barcos de la flota con el fin de que tu equipaje vaya donde tenga que ir. Las etiquetas para el equipaje se personalizan con el nombre y el número de camarote. Las etiquetas de los distintos barcos se identifican mediante el nombre del crucero en negrita para que se vean fácilmente."],
						["Si el pasajero es miembro Platinum, Diamond o Diamond Plus de nuestra Crown & Anchor Society, puedes aprovechar tu prioridad en el check-in y disfruta del salón de salida privado."],
						['En cuanto suba a bordo, y la camarote esté disponible encontrará nuestro programa diario con los horarios de todas las actividades a bordo. Los miembros de la Crown & Anchor Society también encontrarán el catálogo "Ultimate Value Booklet" en el camarote.'],
						['Si viajas con tu familia, asegúrate de comprobar el programa diario para ver la hora del "espectáculo familiar de bienvenida a bordo". En él recibirás toda la información sobre las actividades disponibles para toda la familia.'],
						["Da click aquí para realizar el check in online de Royal Caribbean"],
						["Da click aquí para realizar el check in online de Celebrity Cruises"],
						["Da Click aquí para realizar el check in online de Azamara Club Cruises"],
						["Desembarque"],
						["Con excepción de tu bolso de mano, tu equipaje deberá quedar fuera del camarote la noche anterior a la salida, alrededor de las 24:00 horas. En el programa diario podrán conocer la hora exacta. El día de la salida, se deberá retirar el equipaje en el área de retiro de equipaje de la terminal portuaria."],
						["Los huéspedes desembarcan por códigos de números de acuerdo a los horarios de salida de sus vuelos."],
						["La cantidad de tiempo que toma desembarcar está basada en el tiempo que le toma al barco pasar aduana."]
					]
				}
  			]
  		},
  		{
  			texto: "Noticias",
  			link: "news",
  			variables: [
						[""]
					]
  		},
  		{
  			texto: "Training",
  			link: "/training",
  			variables: [
						[""]
					]
  		},
  		{
  			texto: "Royal Caribbean",
  			colapsar: false,
  			hijos: [
  				{
  					texto: "Información General de la Marca",
  					link: "royal-caribbean",
  					variables: [
						["Royal Caribbean Cruises Ltd."],
						["Información General de la Marca"],
						["A bordo de un crucero Royal Caribbean"],
						["se viven experiencias diferentes que siempre recordarás."],
						["Te sorprenderán nuestros espectáculos, la oferta gastronómica, un servicio inigualable que te hará sentir cómodo en todo momento y por supuesto, disfrutarás de atracciones nunca antes vistas en alta mar."],
						["Sea cuál sea la sensación que buscas, a bordo de un crucero Royal Caribbean"],
						["siempre encontrarás una opción afín a cada persona. Siente la mayor descarga de adrenalina en alta mar con nuestras múltiples actividades o experimenta esa increíble sensación de calma y tranquilidad. ¡Cada día es diferente!"],
						["Es la flota de cruceros"],
						["más innovadora"],
						["La innovación nos ha guiado en la construcción de 25 revolucionarios barcos que son destinos en sí mismos donde podrás hacer, ver y saborear como nunca antes habías imaginado."],
						["Tanto si navegas a bordo de los increíbles barcos de la clase Oasis como si lo haces en cualquier otro, disfrutarás de espectáculos estilo Broadway, actividades para toda la familia, tecnología de última generación, la conexión a internet más rápida en alta mar y camarotes diseñados para inspirar y relajarse, entre muchos otros detalles que marcan la diferencia."],
						["Destinos asombrosos"],
						["Con más de 250 destinos en 75 países de los 6 continentes, escojas las vacaciones que escojas, descubrirás lugares increíbles. Desde navegar por el Mediterráneo y las Islas Griegas, vivir unas exóticas aventuras caribeñas o explorar las culturas milenarias de Asia. ¿Prefieres un clima menos caluroso? Conoce la magia del Norte de Europa o Alaska. ¡Tú decides el destino y nosotros nos encargamos del resto!"],
						["Un servicio de primer nivel"],
						["Nuestro reconocido Gold Anchor Service"],
						["ofrece un alto nivel y una calidad de servicio inigualables que te garantizan cada día las mejores vacaciones."],
						["En cada uno de nuestros barcos tendrás un incomparable servicio personalizado y unos detalles que superarán todas tus expectativas."],
						["Sea cuál sea la sensación que buscas, a bordo de un crucero Royal Caribbean siempre encuentras una opción afín a cada persona. Esto es lo que pueden encontrarán dentro de la flota de Royal Caribbean:"],
						["Todas las comidas*"],
						["Adventure Ocean"],
						["FlowRider"],
						["Pista de patinaje en hielo"],
						["Obras de teatro estilo Broadway"],
						["Minigolf"],
						["Todo el helado que puedas comer"],
						["Pared para escalar"],
						["Albercas"],
						["Espectáculos sobre hielo"],
						["Jacuzzi"],
						["Club nocturno"],
						["Cuadrilátero"],
						["Cine 3D"],
						["Experiencia DreamWorks"],
						["Clases de baile"],
						["Pista de atletismo"],
						["Vapor"],
						["Capilla"],
						["Música en vivo"],
						["Conferencias de programas de enriquecimiento"],
						["Shows de comedia"],
						["Subastas de arte"],
						["24 horas de bocadillos"],
						["Clases de juegos de azar"],
						["Canchas deportivas"],
						["Sauna"],
						["Gimnasio"],
						["Pista de patinaje en línea"],
						["Librería"],
						["Solarium Teen Disco"],
						["Viking Crown Lounge"],
						["Room Service 24 horas***"],
						["H2O Zone"],
						["o Splashaway Bay"],
						["Concursos"],
						["Ping-pong"],
						["Toallas de alberca"],
						["Demostraciones de cocina"],
						["Té/café de filtro"],
						["Karaoke"],
						["Galería de arte"],
						["Selección de bebidas"],
						["Las actividades varían según el barco"],
						["*Comedor principal y Windjammer Café. Un costo suplementario se cobrará en otros lugares para cenar."],
						["***Hay un cargo adicional por este servicio después de medianoche."]
					]
  				},
				{
					texto: "Destinos",
  					link: "ry-destination",
  					variables: [
						["Royal Caribbean Cruises Ltd."],
						["Destinos"],
						["Visitamos cientos de puertos de escala en algunos de los lugares más espectaculares del mundo. Desde la belleza escarpada de las costas de Alaska, Canadá y Nueva Inglaterra hasta el encanto europeo del Viejo Mundo y los exuberantes paisajes de México, Hawái, el Caribe, el Canal de Panamá, Bermudas o Las Bahamas."],
						["Por supuesto que tener lo mejor de ambos mundos puede parecer un cliché, pero se puede cumplir con nuestras excursiones en tierra. Podemos llevarte a aventuras en las montañas, los fiordos, la nieve o la playa. Nuestros emocionantes Cruisetours combinan lo mejor de explorar cada destinó con los beneficios de un crucero."],
						["Cuba"],
						["El Caribe"],
						["Europa"],
						["Golfo Pérsico"],
						["Hawái"],
						["Las Bahamas"],
						["Las Bermudas"],
						["Pacífico Noroeste"],
						["Pacífico Sur"],
						["Reposicionamiento"],
						["Transatléntico"],
						["Transpacífico"],
						["Alaska"],
						["Asia"],
						["Australlia y Nueva Zelanda"],
						["Canadá y Nueva Inglaterra"],
						["Canal de Panamá"]
					]
				},
				{
					texto: "Flota",
  					link: "ry-fleet",
  					variables: [
						["Royal Caribbean Cruises Ltd."],
						["Flota"],
						["Clase Quantum"],
						["Con la Clase Quantum, hemos reinventado la vida en alta mar. Ahora, puedes practicar paracaidismo a bordo gracias al simulador RipCord by iFly"],
						["Sube a la cápsula de observación North StarSM y asciende a 90 metros sobre el nivel del mar para contemplar las vistas de 360° que te ofrece. Y descubre cómo salas enteras del barco se transforman frente a ti. Acércate a SeaplexSM, donde los autos de choque y la escuela de trapecio te invitan a dejarte llevar por la diversión, o pásate por Two70, local en el que te esperan unas vistas del océano sobrecogedoras durante el día y unos espectáculos de entretenimiento de tecnología avanzada durante la noche."],
						["Barcos que pertenecen a la clase Quantum:"],
						["Quantum of the Seas"],
						["Ovation of the Seas"],
						["Anthem of the Seas"],
						["Clase Oasis"],
						["Sólo una osada imaginación podría forjar barcos como los de la Clase Oasis. Descubre un paraíso residencial en los que siete vecindarios llenarán de aventuras tus días y tus noches en crucero. Toma olas en el simulador de surf FlowRider"],
						["o atraviesa velozmente la cubierta con la tirolina. Observa a los clavadistas actuar en el AquaTheater y diviértete con los exitazos musicales traídos de los escenarios de Broadway. Y la aventura de la Clase Oasis alcanza nuevos niveles de intensidad con la inauguración del Harmony of the Seas."],
						["Barcos que pertenecen a la clase Oasis:"],
						["Oasis of the Seas"],
						["Allure of the Seas"],
						["Harmony of the Seas"],
						["Symphony of the Seas"],
						["Clase Freedom"],
						["La acción continúa y a bordo de los cruceros de la Clase Freedom. Pruebe los favoritos de Royal Caribbean como el simulador de surf FlowRider"],
						[", la pista de patinaje sobre hielo y la pared de escalar. Zambúllase en la H2O Zone o haga nuevos amigos con los personajes de DreamWorks a bordo. Los espectáculos, la vida nocturna y el Casino Royale aportan la emoción luego de que oscurece. Todo lo que tiene que traer son nuevos amigos para compartirlo."],
						["Barcos que pertenecen a la clase Freedom:"],
						["Freedom of the Seas"],
						["Independence of the Seas"],
						["Liberty of the Seas"],
						["Clase Voyager"],
						["Los barcos de la Clase Voyager recorren todo el mundo. Así que... ¿adónde irás ahora? Empieza por la Royal Promenade; un lugar de encuentro que recuerda a una calle principal, llena de restaurantes, bares, tiendas y festejos callejeros por la noche que animarán a todos los cruceristas. ¡No te olvides de la piscina y las cubiertas para deportes! Aquí te esperan montones de películas al aire libre, olas para practicar surf en el FlowRider"],
						["y una pared de escalar donde ponerte a prueba y dejar atrás aquellos días de antaño donde te aburrías en la piscina. Olvídate de las vacaciones tradicionales, esto es mucho más."],
						["Barcos que pertenecen a la clase Voyager:"],
						["Voyager of the Seas"],
						["Navigator of the Seas"],
						["Mariner of the Seas"],
						["Adventure of the Seas"],
						["Explorer of the Seas"],
						["Clase Radiance"],
						["En la Clase Radiance, incluso cuando estás en el interior del barco, te sentirás como en el exterior. ¿Por qué decimos esto? Pues porque nuestros fantásticos buques cuentan con un sinfín de cristaleras para que disfrutes más del sol y de las vistas. Incluso los ascensores son de cristal y ofrecen vistas al mar, ¡así no dejarás de rodearte de este ambiente etéreo ni un solo segundo! Siempre tendrás tu próxima aventura a la vista, desde la pared de escalar hasta el campo de minigolf, sin olvidarnos de la pantalla gigante al aire libre donde ver películas junto a la piscina y el enorme abanico de restaurantes exquisitos."],
						["Barcos que pertenecen a la clase Radiance:"],
						["Radiance of the Seas"],
						["Jewel of the Seas"],
						["Brillance of the Seas"],
						["Serenade of the Seas"],
						["Clase Vision"],
						["Los barcos de la Clase Vision son los exploradores de los hemisferios, los verdaderos trotamundos. ¡Y tú también puedes serlo! Siéntete como en casa tanto en Alaska como en el Caribe y en Europa, y degusta una gastronomía que deleitará tus sentidos, vive la magia de la noche con un ambiente único, ríete a carcajadas con nuestros espectáculos cómicos o sueña de la mano de nuestras obras teatrales. Los grandes aventureros podrán descubrir nuevas sensaciones con la pared de escalar, el campo de minigolf y muchas novedades más."],
						["Barcos que pertenecen a la clase Vision:"],
						["Vision of the Seas"],
						["Enchantment of the Seas"],
						["Grandeur of the Seas"],
						["Rhapsody of the Seas"],
						["Clase Sovereign y Clase Empress"],
						["Conoce al nuevo y reinventado Majesty y Empress of the Seas, una escapada para aquellos que trabajan duro y se divierten y aman compartir cada minuto, con acceso gratuito e ilimitado a VOOM, el internet más rápido en alta mar. Fanáticos de toboganes acuáticos y amantes del guacamole fresco. Los que disfrutan tomar sol junto a la piscina y apostar los fines de semana. Aquí podrás sacar al aventurero que llevas dentro"],
						["Barcos que pertenecen a la clase Sovereign y Clase Empress:"],
						["Majesty of the Seas"],
						["Empress of the Seas"]
					]
				},
				{
					texto: "Complementos para el Crucero",
					link:"ry-accesories",
					variables: [
						["Royal Caribbean Cruises Ltd."],
						["Complementos para el Crucero"],
						["A través de nuestra página de internet se pueden contratar todos los Complementos a tu crucero, la forma más conveniente de programar lo que quieres hacer en las vacaciones. Reserva todo, desde asientos para nuestros espectáculos hasta las mesas en nuestros restaurantes de especialidad y los servicios de spa y excursiones en tierra."],
						["Reserva lo que quieres con anticipación con el Calendario de cruceros al menos 180 a 4 días antes de la fecha de salida. Después de iniciar la sesión, se mostrará tu fecha límite para las reservas por anticipado. Si estás dentro del plazo límite, haz tus reservas a bordo."],
						["Bebidas"],
						["Los precios están sujetos a cambios sin previo aviso, incluyen 18% de cargo por servicio. Las propinas pueden agregarse basadas en el itinerario. Los paquetes no pueden compartirse y no son transferibles. Las  solicitudes de reembolso de los Paquetes de Bebidas deberán someterse dentro de las 48 horas de compra para ser consideradas. El costo del paquete de bebidas se debe comprar por el total de noches de crucero. Su cuenta podrá reflejar un impuesto adicional en ciertos puertos o itinerarios. Cuando ordene una selección de bebida a bordo, deberá presentar su tarjeta SeaPass con la estampilla del paquete. El paquete no incluye artículos del mini bar y vasos de souvenir, cervezas de especialidad enlistadas en los menús de los bares, o bebidas de categoría super premium arriba de USD. El paquete está sujeto a los términos de la política de alcohol de Royal Caribbean International"],
						[". No podrá cancelarse después de 48 horas de haber comprado el paquete."],
						["Si algún pasajero desea adquirir alguno de estos paquetes: Paquete Deluxe de bebidas, Paquete Deluxe de bebidas + Internet o Paquete Deluxe de bebidas + Paquete de restaurantes; el resto de los pasajeros que se encuentren en la misma cabina deberán comprarlo de igual manera, siempre y cuando tengan 21 años de edad o mayores."],
						["Esta política aplica tanto para las compras realizadas a bordo como para las compras por internet."],
						["Conozca el Paquete de Bebidas Royal Caribbean"],
						["Gastronomía"],
						["Hay un viaje culinario para todos los gustos esperándolos a bordo. Se pueden reservar mesas en cualquiera de nuestros restaurantes de especialidades en nuestra página oficial. Además, disfrutarán de la comodidad de seleccionar una hora de la cena en el restaurante principal que se ajuste a tu horario con el My Time Dining."],
						["Por un solo precio, se pueden reservar paquetes de cenas, estas opciones permiten al cliente la flexibilidad que guste y la opción de poder repetir sus Restaurantes favoritos."],
						["Los precios son por persona en USD. Los niños de 6 a 12 años cenan en nuestros restaurantes de especialidad por $10 USD por persona, de 5 años o menos es gratis. Los menús de los niños son diferentes. Pueden aplicar cargos por cancelación."],
						["Conozca los Restaurantes Royal Caribbean"],
						["Paquetes Restaurantes"],
						["Entretenimiento"],
						["La hermosa vista no es lo único que te maravillará a bordo de nuestros innovadores cruceros. Nuestros espectáculos gratuitos seguro te harán decir WOW de principio a fin. Siéntate y disfruta de una variedad de producciones increíbles, como los galardonados musicales de Broadway y el teatro West End, producciones al estilo Las Vegas originales, actos de comedia en vivo, y espectáculos acuáticos y de patinaje sobre hielo."],
						["Spa y Gimnasio"],
						["En el spa VitalitySM, nuestras principales preocupaciones son la relajación y el rejuvenecimiento. Deléitate con una variedad de tratamientos que te harán sentir como nuevo. Consiéntete con vigorizantes masajes, tratamientos corporales y tratamientos faciales. Date el regalo de la juventud con los tratamientos de medi-spa como BOTOX"],
						["y Dysport"],
						[". Prepárate para la noche formal con un nuevo peinado y un tratamiento para manos y pies. Con tratamientos para todos, desde parejas, jóvenes y hombres, no cabe duda que encontrarás al menos un placer increíble en nuestro spa."],
						["Excursiones en Tierra"],
						["El mundo es tuyo para que lo explores. Aprovéchalo al máximo reservando excursiones terrestres en cada puerto de tu itinerario. Hay una excursión para todos, desde los aventureros hasta los aficionados a la buena mesa; desde los historiadores a los amantes de los animales. Es tu oportunidad de llegar al corazón de los destinos más atractivos del mundo. Hazlo con una aventura única en su clase que nunca olvidarás. Reserva hoy mismo tus excursiones terrestres."],
						["Internet"],
						["Con Voom los pasajeros podrán escuchar las listas de reproducción en Spotify o compartir los momentos inolvidables de sus vacaciones en Facebook e Instagram. Podrán estar conectado en FaceTime y Skype, así como mandar mensajes de texto y correos electrónicos. Ahora podrán disfrutar todas las películas y programas de Netflix. Desde el Caribe hasta Australia, Voom ya está disponible en todos los barcos de Royal Caribbean alrededor del mundo."],
						["Paquetes Internet"]
					]
				},
				{
					texto: "Club de Lealtad",
					link: "ry-loyalty",
					variables: [
						["Royal Caribbean Cruises Ltd."],
						["Club de Lealtad - Crown & Anchor"],
						["Conoce más de los Beneficios C&A"]
					]
				},
				{
					texto: "Next Cruise",
					link: "ry-next-cruise",
					variables: [
						["Royal Caribbean Cruises Ltd."],
						["NEXT CRUISE"],
						["Conoce más de los Beneficios de Next Cruise"]
					]
				},
				{
					texto: "Materiales",
					link: "ry-media",
					variables: [
						["ROYAL CARIBBEAN MATERIALES"],
						["Nombre"]
					]
				},
				{
					texto: "Videos",
					link: "ry-video",
					variables: [
						[""]
					]
				},
  			]
  		},
  		{
  			texto: "Celebrity Cruises",
  			colapsar: false,
  			hijos: [
  				{
  					texto: "Información General de la Marca",
  					link: "celebrity-cruises",
  					variables: [
						["Información General de la Marca"],
						["Desde 1989 nos hemos hecho un hábito de establecer estándares de la industria, y no planeamos romperlo en el corto plazo. En todos los barcos de toda nuestra flota encontrará calidad superior, diseño elegante y servicio intuitivo. Navega con nosotros y experimenta la distinción de Celebrity."],
						['Celebrity Cruises existe porque creemos en abrir el mundo. Sabemos que viajar nos mejora, a cada uno de nosotros. Estamos aquí para ayudar a los vacacionistas a comprender el valor de los viajes. Nuestros cruceros alientan a las personas a navegar más allá de sus propias fronteras y ampliar sus horizontes. Nuestra icónica "X" es la marca del lujo moderno, la marca de espacios contemporáneos que son a la vez sofisticados y acogedores. Donde la experiencia culinaria está influenciada por la cocina global y diseñada por nuestro chef con estrellas Michelin. Donde nuestro personal brinda un servicio intuitivo, personal y discreto. Donde todo está diseñado para proporcionar vacaciones de crucero de lujo sin precedentes para los viajeros de todas las edades. Nuestros trece barcos galardonados ofrecen experiencias únicas en más de 300 destinos en los siete continentes. Celebrity Cruises se ha hecho famoso en todo el mundo por ofrecer un servicio al cliente atento y altamente personalizado.']
					]
  				},
				{
					texto: "Destinos",
					link: "cc-destination",
					variables: [
						["DESTINOS"],
						["Nuestra flota de Celebrity Cruises viaja por todo el mundo, recorriendo 80 países y más de 280 destinos."],
						["Alaska"],
						["Australia / Nueva Zelanda"],
						["Caribe"],
						["Galápagos"],
						["Bermudas"],
						["América del Sur"],
						["Canadá / Nueva Inglaterra"],
						["Costa Pacífico"],
						["Hawái"],
						["Trastralántico"],
						["Asia"],
						["Canal de Panamá"],
						["Europa"],
						["Las Bahamas"],
						["Transpacífico"]
					]
				},
				{
					texto: "Flota",
					link: "cc-fleet",
					variables: [
						["FLOTA"],
						["Como la flota más nueva en alta mar, los cruceros de Celebrity Cruises son considerados constantemente como los mejores del mundo. Nuestra flota combina los últimos avances tecnológicos con eterna elegancia, cocina gourmet, entretenimiento exclusivo, espaciosos camarotes y el exclusivo servicio por el que Celebrity Cruises es reconocido."],
						["Conoce la Flota Celebrity Cruises"]
					]
				},
				{
					texto: "Complementos para el Crucero",
					link: "cc-accesories",
					variables: [
						["COMPLEMENTOS DEL CRUCERO"],
						["Haz de tu crucero una experiencia aún más personal añadiendo los complementos que mejor se adapten a tus intereses. Cuando hayas reservado un crucero, podrás revisar tu reserva, completar el proceso de check-in online y hacer solicitudes especiales para mejorar tu viaje en crucero."],
						["Excursiones"],
						["En Celebrity Cruises creemos que el conocimiento lo es todo, así que hemos buscado a los mejores expertos locales del mundo entero para que tus excursiones en tierra sean extraordinarias. Ya sea una excursión totalmente personalizada o que aproveches una de nuestras escalas nocturnas para vivir una aventura en tierra de varios días, no hay límites. Las posibilidades son tan amplias como el mundo entero."],
						["A bordo, contamos con expertos de reconocido prestigio que te explicarán la historia y los detalles más fascinantes de los lugares que vas a visitar. Tú solo tienes que pedir, nosotros nos ocupamos de que tu excursión en tierra sea algo memorable."],
						["Tratamientos de Spa"],
						["Te invitamos a mimar tu mente, tu cuerpo y tu espíritu a bordo de los cruceros Celebrity. "],
						["Déjanos transportarte a un mundo completamente nuevo con tratamientos inspirados en rituales de culturas exóticas en nuestro afamado AquaSpa"],
						[". O si lo prefieres, atrévete a disfrutar de una vigorizante clase de spinning con el impresionante océano como telón de fondo detrás de los inmensos ventanales."],
						["Después, date un gusto con una manicura de lujo, un delicado tratamiento facial y disfruta de cada momento al máximo. Sin importar cómo lo hagas, nuestra meta es dejarte renovado y relajado."],
						["Reservas en restaurantes de especialidad"],
						["En Celebrity Cruises cada plato se convierte en una verdadera experiencia sensorial que te hará recorrer el mundo a través de todos tus sentidos. Traza tu propio viaje culinario y ríndete a nuestras tentadoras propuestas, todas ellas diferentes. Y lo mejor de todo es que muchas de ellas están incluidas en el precio del crucero. Imagina unos chefs de gran prestigio creando una selección de platos tradicionales combinados con atrevidas especialidades de autor. Añádale más. Una de las mayores bodegas de vino de alta mar donde nuestros atentos sommeliers te ayudarán a encontrar la botella perfecta para cada ocasión. Todo ello acompañado de un servicio incomparable."],
						["Conoce Nuestros Restaurantes"],
						["Conoce los Paquetes de Restaurantes"],
						["Paquetes de bebidas"],
						["Conoce los Paquetes de Bebidas"],
						["Obsequios a bordo"],
						["Sorprender a tu pareja con una decoración especial del camarote o con un ramo de flores. Regalar un lujoso tratamiento de spa o un crédito a bordo para probar uno de los deliciosos restaurantes de especialidad. Un obsequio de Celebrity Cruises se convierte en el presente ideal para completar tu experiencia a bordo."],
						["Internet"],
						["Sólo porque estás millas mar adentro no significa que tienes que perder el contacto con tus amigos y familia. Con nuestro servicio de internet de alta velocidad recientemente mejorado: XCELERATE, ahora puedes seguir en contacto con videollamadas y servicios de mensajería como Skype, Whatsapp y FaceTime; navegar a toda velocidad; o ver tus series y películas favoritas en streaming. "],
						["Podrás utilizar tu propio móvil, tablet o portátil para conectarte, o usar uno de nuestros ordenadores que ponemos a tu disposición en el Celebrity iLoungeSM que está abierto 24 horas del día. Elije el paquetesde Internet que mejor satisface tus necesidades. XCELERATE estará disponible en breve en todos nuestros barcos, a excepción de los famosos Xpedition"],
						[" que ofrece WiFi en áreas públicas.*"],
						["Conoce Nuestro Paquete de Internet"]
					]
				},
				{
					texto: "Club de Lealtad",
					link: "cc-loyalty",
					variables: [
						["Club de Lealtad"],
						["Captain’s Club de Celebrity Cruises"],
						[" es nuestro programa de reconocimiento y recompensas para huéspedes frecuentes. Diseñado para viajeros en busca de vacaciones llenas de exclusivas experiencias, Captain’s Club ofrece toda una gama de beneficios y amenidades que, sin duda, harán más placentera, cómoda y memorable la estadía con nosotros. Nuestra nueva categoría, Zenith, fue creada exclusivamente para nuestros huéspedes más leales, para ofrecerles la clase de beneficios y privilegios de calidad que corresponden a este nivel de la membresía, entre los que podemos mencionar un paquete de internet de cortesía, acceso al Lounge VIP del Michael’s Club y un paquete Premium de bebidas de su elección."],
						["Conoce Capitan´s Club"]
					]
				},
				{
					texto: "Future Cruise",
					link: "cc-future-cruise",
					variables: [
						["FUTURE CRUISE"],
						["Conoce los Beneficios FUTURE CRUISE"]
					]
				},
				{
					texto: "Materiales",
					link: "cc-media",
					variables: [
						["CELEBRITY CRUISES MATERIALES"],
						["Nombre"]
					]
				},
				{
					texto: "Videos",
					link: "cc-video",
					variables: [
						[""]
					]
				},
  			]
  		},
  		{
  			texto: "Azamara Club Cruises",
  			colapsar: false,
  			hijos: [
  				{
  					texto: "Información General de la Marca",
  					link: "azamara",
  					variables: [
						["Información General de la Marca"],
						["Azamara Club Cruises es una compañía de cruceros que actualmente opera 2 cruceros, el Azamara Quest y el Azamara Journey. La compañía es una subsidiaria de Royal Caribbean Cruises Ltd. La compañía se fundo en 2007 con el nombre de Azamara Cruises y fue refundada en 2009 bajo su nombre actual. Ambos barcos fueron ampliamente renovados de 2012 a 2013."],
						["Actualmente, Azamara Club Cruises opera dos barco que originalmente formaban parte de la clase R de ocho buques construida entre 1998 y  2001 para Renaissance Cruises, Azamara Quest y Azamara Journey se construyeron en 2000 bajo los nombres R six y R seven. Además, en marzo de 2018, al Adonia, un barco gemelo de los barcos anteriores, será tomado por P & O Cruises y se usará bajo el nombre de Azamara Persecución."]
					]
  				},
				{
					texto: "Destinos",
					link: "az-destination",
					variables: [
						["Destinos"],
						["Los barcos de Azamara tienen el tamaño justo para visitar puertos más pequeños que los barcos más grandes no pueden visitar, y para hacer que sea más conveniente experimentar destinos de marquesinas desde su puerta, recorriendo 69 países y más de 200 puertos."],
						["Africa"],
						["Alaska"],
						["Asia"],
						["Australia / Nueva Zelanda"],
						["Caribe"],
						["Cuba"],
						["Mediterráneo"],
						["Europa Norte / Oeste"],
						["Canal de Panamá. Centro y Norte América"],
						["América del Sur"],
						["Pacifico Sur"],
						["Transoceánico"],
						["Maiden Ports"],
						["GUÍA DE DESTINOS AZAMARA"]
					]
				},
				{
					texto: "Flota",
					link: "az-fleet",
					variables: [
						["Flota"],
						["CONOCE LA FLOTA AZAMARA CLUB CRUISES"]
					]
				},
				{
					texto: "Complementos para el Crucero",
					link: "az-accesories",
					variables: [
						["Destinos"],
						["Cree la experiencia ideal a bordo y lleve su viaje de Azamara Club Cruises"],
						[" al siguiente nivel de lujo. Nuestros paquetes incluidos a bordo tienen un precio que ofrece un valor excepcional, todo con nuestro servicio exclusivo."],
						["Saboree comidas especiales, manténgase conectado con su mundo, beba una bebida premium y vea lo que el spa tiene en la tienda. Desde lo esencial, hasta el placer adicional, hasta la indulgencia máxima, nuestros paquetes Experience More logran el equilibrio perfecto de conveniencia y comodidad en tres colecciones rentables."],
						["No podría ser más fácil crear tu experiencia Azamara ideal."],
						["Paquetes de Bebidas "],
						["Una vez a bordo de nuestros íntimos barcos de invitados, Azamara Journey"],
						[", Azamara Quest"],
						[" y Azamara Pursuit"],
						[", no tendrá que pagar más para disfrutar de su bebida nocturna o bebida festiva."],
						["Nuestras amenidades incluyen selectas bebidas estándar, internacionales, y una cambiante selección de dos vinos tintos y dos vinos blancos, y un vino rosado y uno espumoso por copa cada día durante su viaje."],
						["Para aprovechar este increíble placer, simplemente visite uno de nuestros bares o comedores y estamos seguros de que encontrará algo para saciar su sed."],
						["Conoce el Paquete de Bebidas"],
						["Restaurantes de Especialidad "],
						["Cuando se trata de cenar con Azamara Club Cruises"],
						[", queremos llevarte a la cima. Los invitamos a disfrutar de nuestros restaurantes de especialidades, Prime C y Aqualina, con estos fabulosos paquetes de precio reducido. Cuentan con todo, desde las comidas de Chef's Table hasta los menús de cinco platos combinados con los vinos perfectos, y son organizados por un oficial superior o un invitado especial. Desde la sopa de langosta hasta la crème brûlée, queremos que tengas una experiencia celestial a un precio bajo."],
						["Paquetes de Internet"],
						["Manténgase en contacto con su familia, amigos y socios de negocios en su hogar durante su viaje a Azamara con nuestros paquetes de Internet, disponibles para su compra durante los primeros dos días de su viaje. Mientras está a bordo, conéctese a través de su computadora personal, tableta, teléfono inteligente u otro dispositivo. O inicie sesión en una de las estaciones de trabajo In Touch a bordo."],
						["El acceso a Internet a bordo está disponible las 24 horas en In Touch (Deck 10), desde el día de salida hasta las 6:00 a.m. en día de desembarque. WiFi (acceso inalámbrico a Internet) también está disponible en todo el barco. Para aprovechar el servicio WiFi, traiga su propia computadora portátil, que debe estar equipada con una tarjeta de red inalámbrica."],
						["Si usa una computadora Apple"],
						[", el navegador Safari"],
						[" debe tener la versión 3.0 o superior para garantizar la compatibilidad con la red inalámbrica incorporada."],
						["SPA, Salud y Fitness"],
						["Si alguna vez has deseado reiniciar una semana o dos, aquí está. Regálese tratamientos de salud, belleza y restauradores en nuestro nuevo Spa Sanctum. Con un enfoque en el bienestar y el vigor, nuestro spa relajante te ofrece la oportunidad de concentrarte en ti, algo que no siempre tienes tiempo para hacer en casa. "],
						["Disfrute de un masaje frente al mar, una manicura rápida antes de ir a la ciudad para explorar, blanqueamiento de dientes, servicios de peluquería o incluso un tratamiento de acupuntura de curación. Pero más allá de Sanctum Spa, Azamara también se complace en ofrecer una gama completa de clases de acondicionamiento físico y nutrición a bordo, que incluyen capacitación personalizada individual por un costo adicional."],
						["Un viaje a Azamara es la oportunidad perfecta para enfocarse en su salud, así que permítanos brindarle un descanso, relajación y rejuvenecimiento."],
						["Obsequios Abordo"],
						["¿Conoces a alguien que navegue con nosotros? Ya sea un amigo, un familiar, un colega o un ser querido, demuestre su aprecio con un regalo pensativo diseñado para elevar su experiencia a bordo."],
						["Este debe contratarse dos semanas antes de la navegación para garantizar la entrega del obsequio."],
						["El pago solo se aceptará con tarjeta de crédito. Todos los precios están en USD."],
						["Excursiones"],
						["Sumérgete en nuestros destinos con Cruise Global accesible, excursiones en tierra Connect LocalSM: experiencias culturales únicas que acomodan scooters, sillas de ruedas, andadores y más. Con usted en mente, buscamos los tours más accesibles de operadores locales confiables e independientes."],
						["En Azamara, siempre estamos entusiasmados de cultivar las mejores experiencias posibles, tanto a bordo como en tierra, para cada uno de nuestros huéspedes en cada viaje."],
						["Las excursiones en tierra accesibles revelan la cultura auténtica de varios de nuestros puertos para usuarios de sillas de ruedas o huéspedes con problemas de movilidad. Estamos listos para proporcionar un transporte cómodo y accesible y guías conocedores para satisfacer sus necesidades"]
					]
				},
				{
					texto: "Club de Lealtad",
					link: "az-loyalty",
					variables: [
						["Club de Lealtad"],
						["Bienvenido a Le Club Voyage, el programa de recompensas de lealtad de Azamara Club Cruises"],
						[". Es nuestra forma de agradecerles por navegar con nosotros, y vuelvan pronto. Inscribirse en Le Club Voyage es rápido y fácil, y comenzará a ganar puntos y beneficios después de su primer viaje completo de tarifa Azamara"],
						[". "],
						["Con cada viaje gane puntos para noches de cortesía, servicio de Internet y lavandería de cortesía, ahorros en el spa y más."],
						["Obtenga un valor extra con las ofertas especiales Le Club Voyage."],
						["Conozca a otros en la comunidad de Le Club Voyage en reuniones privadas a bordo, eventos especiales y viajes anuales de Le Club Voyage."],
						["Le Club Voyage Ambassador está a su servicio, y nuestro dedicado mostrador on-shore Le Club Voyage puede responder cualquier pregunta sobre puntos y privilegios."]
					]
				},
				{
					texto: "Cruise Again",
					link: "az-next-cruise",
					variables: [
						["Cruise Again"],
						["Los cruceros de primera vez y los miembros de Le Club Voyage disfrutan de ahorros exclusivos cuando reserva mientras está a bordo."],
						["Reserve su próximo viaje mientras está a bordo para disfrutar de ahorros y beneficios exclusivos. ¿A dónde irás después? Para obtener más información o para hacer una reserva, visite el mostrador de ventas de Cruise Again en la Cubierta 4. Si está reservado a través de una agencia de viajes, le devolveremos la reserva a su profesional de viajes."],
						["Conoce los Beneficios Cruise Again"]
					]
				},
				{
					texto: "Materiales",
					link: "az-media",
					variables: [
						["AZAMARA MATERIALES"],
						["Nombre"]
					]
				},
				{
					texto: "Videos",
					link: "az-video",
					variables: [
						[""]
					]
				},
  			]
  		},
  		{
  			texto: "Grupos",
  			link: "/grupos",
  			variables: [
						["Aquí obtendrás acceso a todos nuestros materiales para grupos de las 3 marcas:"],
						["Royal Caribbean, Celebrity Cruises y Azamara Cruises"],
						[", para comenzar a descargar "],
						["materiales accede a cada marca."],
						["Ingresa Aquí"],
						["Ingresa Aquí"],
						["Ingresa Aquí"]
					]
  		},
  		{
  			texto: "Mayoristas",
  			colapsar: false,
  			hijos: [  				
  				{
  					texto: "Comunicados",
  					child: true,
  					hijos: [
  						{
  							texto: "Finanzas",
  							link: '/mayoristas-comunicados-finanzas',
  							variables: [
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
					]
  						},
						{
							texto: "Operaciones",
							link: '/mayoristas-comunicados-operaciones',
							variables: [
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
					]
						},
						{
							texto: "Grupos",
							link: '/mayoristas-comunicados-grupos',
							variables: [
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
					]
						},
						{
							texto: "Marketing",
							link: '/mayoristas-comunicados-marketing',
							variables: [
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
					]
						},
						{
							texto: "Ventas",
							link: '/mayoristas-comunicados-ventas',
							variables: [
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
						[""],
					]
						},
  					]
  				}
  			]
  		}
  	];